export const PatreonIcon = ({ color = "inherit", height = 22, width = 22 }) => (
  <svg
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 50 50`}
    width={width}
    height={height}
  >
    <path d="M32.054 1.092c-9.925 0 -18 8.075 -18 18 0 9.896 8.075 17.944 18 17.944 9.896 0 17.946 -8.05 17.946 -17.944C50 9.167 41.95 1.092 32.054 1.092M0.006 49.035h8.792V1.092H0.006" />
  </svg>
);